import { existsSync, readdirSync } from "fs";
import path from "path";

export function getRngSchemaFileExtension(formSchemasDirPath: string, gfv: string): string {
    if (!Boolean(Number(gfv))) {
        return ".rng.xml";
    }

    try {
        const maxSubversion: number | undefined =
            readdirSync(formSchemasDirPath)
                .map(fileName => fileName.includes(".rng.xml") && !fileName.includes("схема.rng.xml"))
                .filter(i => i === true).length - 1;
        if (
            maxSubversion === undefined ||
            !existsSync(path.join(formSchemasDirPath, `${gfv}.${maxSubversion}.rng.xml`))
        ) {
            return ".rng.xml";
        }
        return `.${maxSubversion}.rng.xml`;
    } catch {
        // eslint-disable-next-line no-console
        console.log(`Folder does not exist. ${formSchemasDirPath}`);
        return ".rng.xml";
    }
}
